<article
  class="info-card"
  [ngSwitch]="infobox.name"
  [class.info-card--secure-infrastructure]="infobox.name === 'secure-infrastructure'"
  [class.info-card--reproducible-workflows]="infobox.name === 'reproducible-workflows'"
  [class.info-card--tools]="infobox.name === 'tools'"
>
  <div class="info-icon-wrap">
    <span class="tile-icon pale" *ngIf="infobox.name === 'data-management'">
      <i class="fa fa-database" aria-hidden="true"></i>
    </span>

    <span class="tile-icon pale" *ngIf="infobox.name === 'help-and-guides'">
      <i class="fa fa-info-circle" aria-hidden="true"></i>
    </span>

    <span class="tile-icon pale" *ngIf="infobox.name === 'secure-infrastructure'">
      <i class="fa fa-shield" aria-hidden="true"></i>
    </span>

    <span class="tile-icon pale" *ngIf="infobox.name === 'reproducible-workflows'">
      <i class="fa fa-refresh" aria-hidden="true"></i>
    </span>

    <span class="tile-icon pale" *ngIf="infobox.name === 'tools'">
      <i class="fa fa-wrench" aria-hidden="true"></i>
    </span>

    <h4>{{ infobox.title }}</h4>
  </div>

  <p>{{ infobox.body }}</p>

  <div class="resource-list resource-list--help" *ngSwitchCase="'help-and-guides'">

    <a href="#" class="resource-button" *ngIf="userIsLoggedIn" (click)="showHelpDialog(); $event.preventDefault()">
      <span class="resource-left">
        <span class="resource-icon">
          <i class="fa fa-question-circle" aria-hidden="true"></i>
        </span>
        Help
      </span>
      <span class="resource-arrow">↗</span>
    </a>

    <a href="mailto:support@humlab.umu.se" target="_blank" class="resource-button">
      <span class="resource-left">
        <span class="resource-icon">
          <i class="fa fa-envelope-o" aria-hidden="true"></i>
        </span>
        E-mail support
      </span>
      <span class="resource-arrow">↗</span>
    </a>
  </div>

  <div class="resource-list" *ngSwitchCase="'tools'">
    <a *ngIf="trattEnabled" [href]="trattUrl" target="_blank" rel="noopener noreferrer" class="resource-button">
      <span class="resource-left">
        <span class="resource-icon">
          <i class="fa fa-pencil" aria-hidden="true"></i>
        </span>
        Open Tratt
      </span>
      <span class="resource-arrow">↗</span>
    </a>

    <div *ngIf="!trattEnabled" class="resource-disabled-message">
      Tratt is currently unavailable in this environment.
    </div>
  </div>

</article>
